import { useQuery } from "@tanstack/react-query";
import { useLocation } from "wouter";
import { useEffect } from "react";

export function useAdmin() {
  const [, setLocation] = useLocation();
  const { data: user, isLoading } = useQuery({
    queryKey: ["/api/auth/user"],
  });

  useEffect(() => {
    if (!isLoading && (!user || user.email !== 'leo.majowka@gmail.com')) {
      setLocation("/");
    }
  }, [user, isLoading, setLocation]);

  return {
    isAdmin: user?.email === 'leo.majowka@gmail.com',
    isLoading,
  };
}
